import { Pipe, PipeTransform } from "@angular/core";
import { getProfileImageRoute } from "@ponder-features/user/profile/profile-image-router";

@Pipe({
    name: "avatarUrl",
    standalone: true
})
export class AvatarUrlPipe implements PipeTransform {
    constructor() {

    }

    public transform(username: string): string {
        return getProfileImageRoute(username);
    }
}